<template>
<div class="row">
    <side-menu :title="'休暇申請履歴'"></side-menu>
    <div class="col-md-10 pt-3">
        <div class="form-group">
            <span style="margin-left:15px;">年</span>
            <select class="search-select custom-select" name="year" v-model="selectedYear" @change="getYukyuList">
                <option v-for="year in yearList" :value="year" :key="year">
                        {{year}}
                </option>
            </select>
            <span style="margin-left:5px;">ステータス</span>
            <select class="search-select custom-select" name="status" v-model="selectedStatus" @change="getYukyuList">
                <option selected="true"></option>
                <option v-for="status in statusList" :value="status" :key="status">
                    {{status}}
                </option>
            </select>
            <span style="margin-left:5px;">申請種類</span>
            <select class="search-select custom-select" name="status" v-model="selectedRequestType" @change="getYukyuList">
                <option selected="true"></option>
                <option v-for="type in requestTypeList" :value="type" :key="type">
                    <span v-if="type==1">有給</span>
                    <span v-if="type==2">特別休暇</span>
                </option>
            </select>
        </div>
        <div v-if="yukyuList.length == 0">まだレコードはありません</div>
        <div v-else>
            <table class="table table-bordered table-responsive">
                <thead class="thead-light">
                <tr>
                    <th>No</th>
                    <th>氏名</th>
                    <th>対象日</th>
                    <th>種類</th>
                    <th>全休/半休</th>
                    <th>特別休暇種別</th>
                    <th>申請理由</th>
                    <th>ステータス</th>
                    <th>申請日</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="(result, index) in yukyuList" :key="index">
                        <td>{{(pagination.currentPage * dispMaxSize) + index + 1}}</td>
                        <td>{{result.userName}}</td>
                        <td>{{result.targetDate}}</td>
                        <td>
                            <span v-if="result.requestType == 1">有給</span>
                            <span v-if="result.requestType == 2">特別休暇</span>
                        </td>
                        <td>{{result.type}}</td>
                        <td>{{result.specialLeaveName}}</td>
                        <td>{{result.reason}}</td>
                        <td>{{result.status}}</td>
                        <td>{{result.createdAt | date}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="text-right">
            <pagination v-if="yukyuList.length > 0" :pagination="pagination"></pagination>
        </div>
    </div>
</div>
</template>

<style scoped>
.noflap{
 white-space: nowrap;
}
</style>

<script>
import SideMenu from "../SideMenu.vue";
import LeaveRequestAPI from '../../../api/leave-request-api'
import UserAPI from '../../../api/user-api'
import CommonAPI from '../../../api/common-api'
import moment from 'moment'
import Pagination from '../../Pagination.vue'

export default {
  name: "leave-request-history",
  components: {
    SideMenu,
    Pagination
  },
  data() {
    return {
      loginUser: {
        role: ''
      },
      yearList: [],
      statusList: ['申請中', '差し戻し', '承認済み'],
      // 1:有給, 2:特別休暇
      requestTypeList: [1, 2],
      yukyuList: [],
      selectedYear: moment().format("YYYY"),
      selectedUserId: '',
      selectedStatus: '',
      selectedRequestType: '',
      dispMaxSize: 20,
      pagination: {
        // 現在ページ
        currentPage: 0,
        // 最大表示ページ件数
        dispMaxPageSize: 5,
        // トータルページ数
        totalPages: 0
      }
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
        this.loginUser = this.$root.$refs.asnHeader.$data.loginUser
        this.selectedUserId = this.loginUser.userId
        this.getYearList()
    },
    // ページ移動を検知
    'pagination.currentPage': function (val) {
      this.getYukyuList()
    }
  },
  mounted () {
  },
  methods: {
    // 年一覧取得
    getYearList () {
      LeaveRequestAPI.getYearList()
        .then(res => {
            this.yearList = res
            this.getYukyuList()
        })
        .catch(err => {
            console.error(err)
        })
    },
    // 有給一覧取得
    getYukyuList () {
      this.$root.$refs.loading.$data.show = true
      let params = {}
      params['year'] = this.selectedYear
      params['userId'] =  this.selectedUserId
      params['status'] = this.selectedStatus
      params['requestType'] = this.selectedRequestType
      params['pageSize'] = this.dispMaxSize
      params['pageNo'] = this.pagination.currentPage ? this.pagination.currentPage : 0
      LeaveRequestAPI.getYukyuList(params)
        .then(res => {
            if (res.content){
              this.pagination.totalPages = res.totalPages
              this.yukyuList = res.content
            } else {
              this.pagination.totalPages = 0
              this.pagination.currentPage = 0
              this.yukyuList = []
            }
            this.$nextTick(function() {
                $(".close").click()
                this.$root.$refs.loading.$data.show = false
            })
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
  },
  filters: {
    date: function (data) {
      return data ? moment.localeData().preparse(moment(data).format("YYYY-MM-DD")) : ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/operator/leave_request/LeaveRequestHistory.vue